import { createContext } from 'react';

export const MainContext = createContext();

export const ShopContext = createContext();

export const UserContext = createContext();

export const AdminContext = createContext();

export const ErrorContext = createContext();
